// extracted by mini-css-extract-plugin
export default {"row":"row-_aF7V","rowSolt":"row-solt-Mv0TC"};